﻿import { ColumnsBase, fieldsProxy } from "@serenity-is/corelib";
import { Column } from "@serenity-is/sleekgrid";

export interface DocumentsTrashColumns {
    FileName: Column;
    DeletedBy: Column;
    DeletedOn: Column;
    ProjectId: Column;
    WbsElementId: Column;
    TaskId: Column;
    OriginalPath: Column;
}

export class DocumentsTrashColumns extends ColumnsBase {
    static readonly columnsKey = 'DocumentManagement.DocumentTrash';
    static readonly Fields = fieldsProxy<DocumentsTrashColumns>();
}